import React, { createContext, useContext, useMemo } from "react";
import { themeModes } from "../theme";

export const ThemeContext = createContext({
    mode: themeModes.dark,
    setMode: () => {},
    toggleTheme: () => {},
});

export const useThemeMode = () => useContext(ThemeContext);

export const ThemeProvider = ({ mode, setMode, children }) => {
    const value = useMemo(
        () => ({
            mode,
            setMode,
            toggleTheme: () =>
                setMode((currentMode) =>
                    currentMode === themeModes.dark
                        ? themeModes.light
                        : themeModes.dark,
                ),
        }),
        [mode, setMode],
    );

    return (
        <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    );
};
